<template>
  <!-- This is a renderless component that only handles ActionCable subscriptions -->
</template>

<script>
export default {
  name: 'ExportFailureSubscriber',

  channels: {
    StoriesChannel: {
      received(data) {
        this.handleExportNotification(data)
      }
    }
  },

  mounted() {
    this.$cable.subscribe({
      channel: 'StoriesChannel'
    })
  },

  beforeDestroy() {
    this.$cable.unsubscribe({
      channel: 'StoriesChannel'
    })
  },

  methods: {
    handleExportNotification(data) {
      const { action, error_message, success_count, failure_count, successes, failures } = data

      if (action === 'export_failure') {
        this.$store.dispatch('messages/addPersistentAlert', error_message)
      } else if (action === 'bulk_export_result') {
        this.handleBulkExportResult(success_count, failure_count, successes, failures)
      }
    },

    handleBulkExportResult(successCount, failureCount, successes, failures) {
      const totalCount = successCount + failureCount
      
      // Build the unified message with better formatting
      let message = `Bulk Export Complete (${totalCount} ${totalCount === 1 ? 'story' : 'stories'})\n`
      
      if (successCount > 0) {
        message += `\nSuccessfully exported ${successCount}:`
        if (successCount <= 5) {
          // Show story names if 5 or fewer
          successes.forEach(s => {
            message += `\n  - Story ${s.id}: ${s.name}`
          })
        }
      }
      
      if (failureCount > 0) {
        message += `${successCount > 0 ? '\n' : ''}\nFailed to export ${failureCount}:`
        failures.forEach(f => {
          const errorMsg = f.error.replace(/^Story \d+ "[^"]+": /, '') // Strip redundant prefix
          message += `\n  - Story ${f.id}: ${f.name} - ${errorMsg}`
        })
      }
      
      // Determine message type and persistence
      let messageType
      let persistent = false
      
      if (failureCount === 0) {
        // All succeeded - green, auto-dismiss
        messageType = 'success'
        persistent = false
      } else if (successCount === 0) {
        // All failed - red, persistent
        messageType = 'alert'
        persistent = true
      } else {
        // Mixed results - yellow, persistent
        messageType = 'warning'
        persistent = true
      }
      
      // Dispatch to messages store
      if (persistent) {
        this.$store.dispatch(`messages/addPersistent${this.capitalize(messageType)}`, message)
      } else {
        this.$store.dispatch(`messages/add${this.capitalize(messageType)}`, message)
      }
    },
    
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  }
}
</script>
